import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "w100 mb20" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "fl w30 pad10" }
const _hoisted_4 = { class: "fw600 pad10" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", {
  class: "mt10 pad10",
  style: {}
}, " waaqのAPI連携を行い、外部のフォーム完了からwaaqのフォームに自動で埋めることができます。（β版） ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "fl w60 mt30" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "APIキーを発行にするには、担当者にお問い合わせください。", -1)
const _hoisted_10 = {
  key: 1,
  class: "w100"
}
const _hoisted_11 = { class: "fw600 pad10" }
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", {
  class: "mt10 pad10",
  style: {}
}, " waaqのAPI連携を行い、外部のフォーム完了からwaaqのフォームに自動で埋めることができます。（β版） ", -1)
const _hoisted_14 = {
  key: 0,
  class: "fl w60",
  style: {"margin-top":"20px"}
}
const _hoisted_15 = {
  class: "fl",
  style: {"width":"280px"}
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  class: "centered",
  style: {"margin-top":"50px"}
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "grey" }, "APIキーが見つかりませんでした。", -1)
const _hoisted_21 = ["src"]
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "mt20 w100" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"300px"} }, "APIキー"),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"150px"} }, "作成日"),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"150px"} }, "最後に利用した日時"),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"150px"} }, "発行者"),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"100px"} }, " ")
], -1)
const _hoisted_25 = ["src", "onClick"]
const _hoisted_26 = {
  key: 1,
  style: {"margin-top":"50px"}
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CopyButton = _resolveComponent("CopyButton")!
  const _component_RoomsLoader = _resolveComponent("RoomsLoader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.rm.canUseOption(`management_api_key`, false))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h5", _hoisted_4, [
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/icons/key.png`),
                width: "28",
                height: "28",
                class: "pointer fl mr10",
                style: {"margin-top":"-8px"}
              }, null, 8, _hoisted_5),
              _createTextVNode("API連携 ")
            ]),
            _hoisted_6,
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("button", {
              type: "submit",
              class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 mr20",
              style: {"height":"50px"},
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.requestApiKey && _ctx.requestApiKey(...args)))
            }, " リクエスト ")
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", {
            class: _normalizeClass(`fl  pad10 ${_ctx.scope == `room_setting` ? `w100` : `w30`}`)
          }, [
            _createElementVNode("h5", _hoisted_11, [
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/icons/key.png`),
                width: "28",
                height: "28",
                class: "pointer fl mr10",
                style: {"margin-top":"-8px"}
              }, null, 8, _hoisted_12),
              _createTextVNode("API連携 ")
            ]),
            _hoisted_13
          ], 2),
          (_ctx.scope == `user_group`)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      type: "submit",
                      class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 mr20",
                      style: {"height":"50px"},
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.createApiKey && _ctx.createApiKey(...args)))
                    }, " 新規発行 ")
                  ])
                ]),
                _hoisted_16,
                (_ctx.apiKeys)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      (_ctx.apiKeys.length == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _hoisted_20,
                              _createElementVNode("img", {
                                src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                                width: "40",
                                height: "40"
                              }, null, 8, _hoisted_21)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createElementVNode("table", _hoisted_23, [
                              _hoisted_24,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apiKeys, (keyDic, keyindex) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: keyindex,
                                  style: {"height":"40px"}
                                }, [
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_CopyButton, {
                                      buttonName: keyDic.key_id,
                                      linkUrl: keyDic.key_id,
                                      styleNone: true
                                    }, null, 8, ["buttonName", "linkUrl"])
                                  ]),
                                  _createElementVNode("td", null, _toDisplayString(keyDic.created_at
                                            ? _ctx.DateTime.fromSeconds(keyDic.created_at).toFormat(`yyyy/MM/dd HH:mm`)
                                            : `-`), 1),
                                  _createElementVNode("td", null, _toDisplayString(keyDic.last_used_at
                                            ? _ctx.DateTime.fromSeconds(keyDic.last_used_at).toFormat(`yyyy/MM/dd HH:mm`)
                                            : `-`), 1),
                                  _createElementVNode("td", null, _toDisplayString(keyDic.owner_user_email), 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("img", {
                                      src: _ctx.$getAssetImageUrl(`/assets/icons/trash.png`),
                                      width: "20",
                                      height: "23",
                                      class: "pointer fl mr15 ml10",
                                      onClick: ($event: any) => (_ctx.removeApiKey(keyDic.key_id))
                                    }, null, 8, _hoisted_25)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]))
                    ]))
                  : (_openBlock(), _createElementBlock("section", _hoisted_26, [
                      _createVNode(_component_RoomsLoader)
                    ]))
              ]))
            : _createCommentVNode("", true),
          _hoisted_27
        ])),
    _hoisted_28
  ]))
}